import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
export const fetchUserInfo = () => {
  PortalIdParser.get();
  return userInfo();
};